import API from "./api";

const RubriqueService = {
  getAll: async () => {
    const response = await API.get("/rubriques");
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/rubriques/${id}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/rubriques", payload);
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(`/rubriques/${id}`, payload);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/rubriques/${id}`);
    return response.data.donnees;
  },
};

export default RubriqueService;
